import { useEffect } from "react";
import { isModalOpen } from "@web/ui/Modal";
import { runCommand } from "./commands";
import { bindingOrder, isActivatableTarget, isTypingTarget } from "./keymap";
import { createShortcutHandler } from "./shortcutDispatch";

/** Binds every shortcut in the keymap to the command registry for the lifetime of the shell. */
export function useKeyBindings(): void {
  useEffect(() => {
    const handler = createShortcutHandler(bindingOrder(), {
      run: runCommand,
      ignore: (event) => {
        if (event.isComposing) return true;
        const chord = event.metaKey || event.ctrlKey;
        // Letters typed into fields are text; dialogs own their keys (except the palette chord).
        if (!chord && isTypingTarget(event.target as HTMLElement | null)) return true;
        if (!chord && isModalOpen()) return true;
        return false;
      },
      skip: (event, spec) => {
        const target = event.target as HTMLElement | null;
        const chord = event.metaKey || event.ctrlKey;
        if (!chord && isTypingTarget(target) && !spec.allowInInput) return true;
        // Enter and Space on a focused button, link or field do what that element does.
        if ((event.key === "Enter" || event.key === " ") && isActivatableTarget(target))
          return true;
        return false;
      },
    });
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);
}
